import React from 'react';

import './inputOutlet.style.scss';
import classNames from 'classnames';
interface IInputOutletProps extends React.HTMLProps<HTMLInputElement> {
  label: string;
  secondaryTitle?: React.ReactNode;
  required?: boolean;
  errors?: string;
  name: string;
  touched?: boolean;
}

const InputOutlet = ({
  label,
  required = false,
  errors,
  touched,
  name,
  secondaryTitle,
  ...props
}: IInputOutletProps) => {
  return (
    <div className="floating-label-input">
      <input
        type={props.type}
        id={name}
        name={name}
        {...props}
        className={
          (touched && errors && !props.disabled ? 'invalid ' : '') +
          (touched && !errors && !props.disabled ? 'valid' : '')
        }
      />
      <label htmlFor={name}>
        <span
          className={classNames({
            'label-invalid ': touched && errors && !props.disabled,
            'label-valid': touched && !errors && !props.disabled,
          })}
        >
          {label}
        </span>
        {required && label && <span className="color-red-3">*</span>}
      </label>
      {secondaryTitle && (
        <span className="secondary-title text-sm">{secondaryTitle}</span>
      )}
      {touched && errors && !props.disabled && (
        <>
          <div className="pt-1">
            <small>
              <i className="icon-warning"></i> {errors}
            </small>
          </div>
          {!secondaryTitle && (
            <span className="input-icon invalid">
              <i className="icon-error-field"></i>
            </span>
          )}
        </>
      )}

      {touched && !errors && !props.disabled && !secondaryTitle && (
        <span className="input-icon valid">
          <i className="icon-success-field"></i>
        </span>
      )}
    </div>
  );
};

export default InputOutlet;
